// ─── Enterprise SSO (SAML federation) ────────────────────────────────────────
// FMP-AU-004: "support enterprise SSO via SAML federation to an external IdP
// without storing user passwords locally."
//
// Federation is performed by the Cognito Hosted UI, so all this module does is
// start the redirect and report whether SSO is available. Deliberately no token
// handling: Amplify owns the PKCE code exchange (see SsoCallbackPage).
//
// Nothing here names the identity provider. REACT_APP_SSO_PROVIDER holds the
// Cognito IdP name (e.g. "EnterpriseIdP"), so replacing the Google Workspace
// test IdP with the client's real one is an env change. Keep the button label
// vendor-neutral for the same reason.
import { signInWithRedirect } from "aws-amplify/auth";
import { isHostedUiConfigured } from "../amplify/aws-exports";

const SSO_PROVIDER = (process.env.REACT_APP_SSO_PROVIDER || "").trim();

/**
 * True only when both halves are present: a Hosted UI to redirect to, and an
 * identity provider name to redirect at. Either one missing means the button
 * must not render — offering a sign-in path that dead-ends on a Cognito error
 * page is worse than not offering it at all.
 */
export function isSsoEnabled() {
  return isHostedUiConfigured && SSO_PROVIDER.length > 0;
}

export function getSsoProviderName() {
  return SSO_PROVIDER;
}

/**
 * Hand the browser to the Hosted UI, which redirects on to the IdP.
 * Only resolves if the redirect fails to start — on success the page is gone.
 */
export async function startSsoLogin() {
  if (!isSsoEnabled()) {
    throw new Error("SSO is not configured for this environment.");
  }
  // `custom` marks this as a user-pool identity provider referenced by name,
  // rather than one of Amplify's built-in social providers.
  await signInWithRedirect({ provider: { custom: SSO_PROVIDER } });
}
